import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useLang } from "../../utils/i18n";

const tr = {
  pt: { text: "Este site utiliza cookies para melhorar a sua experiência.", accept: "Aceitar", more: "Saber mais" },
  en: { text: "This site uses cookies to improve your experience.", accept: "Accept", more: "Learn more" },
  es: { text: "Este sitio utiliza cookies para mejorar su experiencia.", accept: "Aceptar", more: "Saber más" },
  fr: { text: "Ce site utilise des cookies pour améliorer votre expérience.", accept: "Accepter", more: "En savoir plus" },
  br: { text: "Este site utiliza cookies para melhorar a sua experiência.", accept: "Aceitar", more: "Saiba mais" },
};

export const CookieConsent = () => {
  const [show, setShow] = useState(false);
  const { lang } = useLang();
  const t = tr[lang] || tr.pt;

  useEffect(() => {
    if (!localStorage.getItem("sophitris_cookies")) setShow(true);
  }, []);

  const accept = () => {
    localStorage.setItem("sophitris_cookies", "accepted");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4" data-testid="cookie-banner">
      <div className="max-w-4xl mx-auto bg-[var(--black-graphite)] border border-[var(--border-subtle)] px-6 py-4 flex flex-col sm:flex-row items-center gap-4">
        <p className="text-[var(--text-secondary)] text-sm flex-1">{t.text}</p>
        <div className="flex items-center gap-3">
          <Link to="/cookies" className="text-[var(--gold)] text-xs tracking-wider hover:underline">{t.more}</Link>
          <button onClick={accept} className="bg-[var(--gold)] text-[var(--black-deep)] text-xs font-semibold px-5 py-2 tracking-wider uppercase hover:brightness-110 transition" data-testid="cookie-accept">{t.accept}</button>
        </div>
      </div>
    </div>
  );
};
